import { call, put, select } from 'redux-saga/effects';
import { betMessages } from 'constants/toastMessages';
import { placedBetSelector } from 'core/widgets/Bet/selectors';
import { getDoubleBet, getBetSum } from 'core/widgets/Bet/utils';
import { tableBetLimitSelector } from 'core/widgets/TableSettings';
import { addToastAction } from 'core/widgets/Toast/actions';
import { balanceSelector } from 'core/widgets/User';
import { ToastTypes } from 'types/toast';
import { TableLimitsType } from 'core/widgets/TableSettings/types';
import { updateBetsSaga } from 'core/widgets/Bet/sagas/createPendingBetSaga';
import { doubleBetSuccessAction } from '../actions';

export function* doubleBetSaga() {
  const balance: number | null = yield select(balanceSelector);
  const tableLimits: TableLimitsType | undefined = yield select(tableBetLimitSelector);
  const { present, past } = yield select(placedBetSelector);

  if (!balance || !tableLimits) {
    return;
  }

  const { doubledBets } = getDoubleBet({ placedBets: present });

  const doubledBetSum: number = getBetSum(doubledBets);

  if (doubledBetSum > balance) {
    yield put(addToastAction({ type: ToastTypes.ERROR, value: betMessages.LOW_BALANCE }));
    return;
  }

  if (doubledBetSum > tableLimits.total.max) {
    yield put(addToastAction({ type: ToastTypes.ERROR, value: betMessages.MAX_BET_REACHED }));
    return;
  }

  const hasExceededIndividualLimit = Object.entries(doubledBets).some(
    ([slot, betValue]) => betValue > 0 && tableLimits[slot] && betValue > tableLimits[slot].max,
  );

  if (hasExceededIndividualLimit) {
    yield put(addToastAction({ type: ToastTypes.ERROR, value: betMessages.MAX_BET_REACHED }));
    return;
  }

  yield put(doubleBetSuccessAction());
  yield call(updateBetsSaga, { past: [...past, present], present: doubledBets });
}
